var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "0" } },
    [
      _c(
        "v-menu",
        {
          staticStyle: { "box-shadow": "none" },
          attrs: {
            "border-radius": "",
            top: "",
            "offset-y": "",
            transition: "slide-y-transition",
            "close-on-click": "",
            "close-on-content-click": ""
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var menu = ref.on
                return [
                  _vm.locationActive
                    ? _c(
                        "v-btn",
                        _vm._g(
                          {
                            staticClass: "my-location-btn",
                            attrs: {
                              small: "",
                              fab: "",
                              title: _vm.$t(
                                "myLocation.stopShowingCurrentLocation"
                              )
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.activatorClicked()
                              }
                            }
                          },
                          menu
                        ),
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                large: "",
                                color:
                                  _vm.continuously === true ? "primary" : "dark"
                              }
                            },
                            [_vm._v("my_location")]
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-btn",
                        _vm._g(
                          {
                            staticClass: "my-location-btn",
                            attrs: {
                              small: "",
                              fab: "",
                              title: _vm.$t("myLocation.showCurrentLocation")
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.activatorClicked()
                              }
                            }
                          },
                          menu
                        ),
                        [
                          _c(
                            "v-icon",
                            { attrs: { large: "", color: "dark" } },
                            [_vm._v("person_pin_circle")]
                          )
                        ],
                        1
                      )
                ]
              }
            }
          ]),
          model: {
            value: _vm.menuOpen,
            callback: function($$v) {
              _vm.menuOpen = $$v
            },
            expression: "menuOpen"
          }
        },
        [
          _vm._v(" "),
          !_vm.locationActive
            ? _c(
                "v-list",
                {
                  staticClass: "input-pop-up-list",
                  staticStyle: { "border-radius": "20px" },
                  attrs: { light: "" }
                },
                [
                  _c(
                    "v-list-tile",
                    {
                      key: "1",
                      on: {
                        click: function($event) {
                          return _vm.setLocationFromBrowser(true)
                        }
                      }
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-list-tile-content",
                                      _vm._g({}, on),
                                      [
                                        _c("v-list-tile-title", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t("myLocation.continuously")
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            136719948
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("myLocation.continuouslyLocation"))
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-avatar",
                        [
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("autorenew")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    {
                      key: "2",
                      on: {
                        click: function($event) {
                          return _vm.setLocationFromBrowser()
                        }
                      }
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-list-tile-content",
                                      _vm._g({}, on),
                                      [
                                        _c("v-list-tile-title", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t("myLocation.onlyOnce")
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1195728839
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("myLocation.onlyOnceLocation"))
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-avatar",
                        [
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("play_for_work")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a46281f", { render: render, staticRenderFns: staticRenderFns })
  }
}